import React from 'react'
import PropTypes from 'prop-types'

import ToggleableSection from 'components/ToggleableSection'
import EngagementStage, { SegmentName, Criteria } from '../components/EngagementStage'
import { getSegmentValue } from 'components/SegmentSelector/segment-service'
import { withContext } from '../Context'
import './index.scss'

export const EngagementStageSelector = ({ segment, onError }) => {
  const currentValues = getSegmentValue(segment, Criteria, SegmentName)
  const hasError = !currentValues || !currentValues.length
  if (onError) {
    onError('EngagementStageSelector', hasError)
  }

  return (
    <div className="engagement-stage-selector-comp">
      <ToggleableSection
        title="Engagement Stage"
        info="The students who have engaged with your college"
        hasError={!currentValues || !currentValues.length}
      >
        <EngagementStage currentValues={currentValues} />
      </ToggleableSection>
    </div>
  )
}

EngagementStageSelector.propTypes = {
  segment: PropTypes.object,
  onError: PropTypes.func,
}

export default withContext(EngagementStageSelector)
